import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment as env } from '@environments/environment'
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiResult} from '../../../shared/model/Index';
import { ISportSeason } from '../model/sportseason';
import { Guid } from 'guid-typescript';
import { ISportSeasonResult } from '@app/modules/search/model/studentSearchResult';


@Injectable({ providedIn: 'root' })

export class SportSeasonService {
    public showSpinner = new BehaviorSubject(false);
    constructor(private http: HttpClient) { }

    get(studentId:Guid) {
        return this.http.get<ApiResult<ISportSeasonResult[]>>(env.apiUrl + 'SportSeason/Get/' + studentId).pipe(
            tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false))
        );
    }

    getPrimary(studentId:Guid) {
        return this.http.get<ApiResult<ISportSeasonResult[]>>(env.apiUrl + 'SportSeason/GetPrimary/' + studentId).pipe(
            tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false))
        );
    }

    getSportSeasonById(id:Guid) {
        return this.http.get<ApiResult<ISportSeason>>(env.apiUrl + 'SportSeason/' + id).pipe(
            tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false))
        );
    }

    post(sportSeason: ISportSeason) {
        return this.http.post<ApiResult<number>>(env.apiUrl + 'SportSeason', sportSeason);
    }
    put(sportSeason: ISportSeason) {
        return this.http.put<ApiResult<number>>(env.apiUrl + 'SportSeason', sportSeason);
    }
    delete(id:Guid) {
        return this.http.delete<ApiResult<any>>(env.apiUrl + 'SportSeason/' + id);
    }
}